import { bootstrapApplication } from '@angular/platform-browser';
import { MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from '@environment';
import { merge } from 'lodash-es';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

function transformEnvironment(baseEnv: any, newEnv: any) {
    merge(baseEnv, newEnv);
}

async function bootstrap() {
    const appRef = await bootstrapApplication(AppComponent, appConfig);
    appRef.bootstrap(MsalRedirectComponent);
}

fetch('assets/environments/environment.json')
    .then(response => response.json())
    .then(async newEnv => {
        transformEnvironment(environment, newEnv);
    })
    .then(async () => {
        if (environment.app === 'dev') {
            return fetch('assets/environments/environment.local.json')
                .then(response => response.json())
                .then(async localEnv => {
                    transformEnvironment(environment, localEnv);
                })
                .catch(_ => {
                    return Promise.resolve();
                });
        }

        return Promise.resolve();
    })
    .then(async () => {
        await bootstrap();
    })
    .catch(err => console.error(err));
